import { PhoneOutlined } from "@ant-design/icons";
import { Select } from "antd";
import { useCallback, useState } from "react";
import { postUserChangeAccessRole } from "tm-shared/api";

import { PrimaryText, SecondaryText } from "@/components/Typography/Styled";
import { isManagerRole } from "@/hooks/isManagerRole";
import { useAppDispatch, useAppSelector } from "@/hooks/redux";
import { useResetApp } from "@/hooks/useResetApp";
import { StyledUserCard } from "@/pages/Profile/MainInformation/Styled";
import { clearSVActiveSchedule } from "@/store/slices/sv";

import { StyledInfoBlock, StyledPhoneLink } from "./Styled";

export const UserInfo = () => {
    const [changeRoleLoading, setChangeRoleLoading] = useState(false);

    const { roleName, team, routeName, availableRoles, role } = useAppSelector(
        (state) => state.user,
    );

    const dispatch = useAppDispatch();

    const { handleReset } = useResetApp();

    const handleChangeRole = useCallback(
        (value) => {
            (async () => {
                if (isManagerRole(role)) {
                    dispatch(clearSVActiveSchedule());
                }
                setChangeRoleLoading(true);
                await postUserChangeAccessRole({ roleSlug: value });

                await handleReset();

                setChangeRoleLoading(false);
            })();
        },
        [handleReset],
    );

    return (
        <StyledUserCard>
            <StyledInfoBlock $borderBottom>
                <PrimaryText fontSize={16} fontWeight="500">
                    Роль
                </PrimaryText>

                {availableRoles.length > 1 ? (
                    <Select
                        options={availableRoles}
                        value={role}
                        onChange={handleChangeRole}
                        disabled={changeRoleLoading}
                        loading={changeRoleLoading}
                    />
                ) : (
                    <SecondaryText>{roleName}</SecondaryText>
                )}
            </StyledInfoBlock>

            {team?.teamName ? (
                <StyledInfoBlock $borderBottom>
                    <PrimaryText fontSize={16} fontWeight="500">
                        Команда
                    </PrimaryText>

                    <SecondaryText>{team?.teamName}</SecondaryText>
                </StyledInfoBlock>
            ) : null}

            {routeName && (
                <StyledInfoBlock $borderBottom>
                    <PrimaryText fontSize={16} fontWeight="500">
                        Маршрут
                    </PrimaryText>

                    <SecondaryText>{routeName}</SecondaryText>
                </StyledInfoBlock>
            )}

            {team?.manager?.roleName && (
                <StyledInfoBlock>
                    <PrimaryText fontSize={16} fontWeight="500">
                        {team?.manager?.roleName}
                    </PrimaryText>

                    <PrimaryText>{team?.manager?.fullName}</PrimaryText>

                    <StyledPhoneLink href={`tel:${team?.manager?.phone}`}>
                        <PrimaryText>{team?.manager?.phone}</PrimaryText>

                        <PhoneOutlined />
                    </StyledPhoneLink>
                </StyledInfoBlock>
            )}
        </StyledUserCard>
    );
};
